/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import ObservableComponentBase from '../Utility/Component/Observable/ObservableComponentBase';
import ObservableStringComponent from '../Utility/Component/Observable/ObservableStringComponent';
import LocalizationComponent from './LocalizationComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Provides an observer pattern for the currently loaded localization resource. */
@cc._decorator.ccclass
export default class ObservableResourceComponent extends ObservableStringComponent
{
    /** The key for this localization resource. */
    @property({ visible: true })
    private _key: string = "group/property";

    /** The collection of observable localizations. */
    @property({ type: [ObservableComponentBase], visible: true })
    private _values: ObservableComponentBase<string | number>[] = [];

    /** @hidden */
    private _localRef: InjectableComponent<LocalizationComponent> = new InjectableComponent();

    /** @hidden */
    protected setContexts(): void
    {
        this._localRef.SetContext(LocalizationComponent);
    }

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this.bindListeners();
    }

    /** @hidden */
    protected onDestroy(): void
    {
        this.unBindListeners();

        super.onDestroy();
    }

    /** @hidden */
    private updateCurrentCultureValue = (): void =>
    {
        if (!this._localRef.Value || !this._localRef.Value.HasLoaded) { return; }
        let replacementValues: string[] = [];

        this._values.forEach((x) => (x !== null && x.Value !== null) && replacementValues.push(x.Value.toString()));

        let value: string = this._localRef.Value.GetStringResource(this._key, ...replacementValues);

        // Explicit call to set value to trigger parent change event.
        this.Value = value;
    }

    /** @hidden */
    private onCultureChangedHandler = (): void =>
    {
        this.updateCurrentCultureValue();
    }

    /** @hidden */
    private bindListeners(): void
    {
        if (this._localRef.HasValue())
        {
            this._localRef.Value.OnChanged(this.onCultureChangedHandler);
        }
        this._values.forEach((x) => x.OnChanged(this.updateCurrentCultureValue));
    }

    /** @hidden */
    private unBindListeners(): void
    {
        if (this._localRef.HasValue())
        {
            this._localRef.Value.OffChanged(this.onCultureChangedHandler);
        }
        this._values.forEach((x) => { if(x) { x.OffChanged(this.updateCurrentCultureValue); } });
    }
}
